// extracted by mini-css-extract-plugin
module.exports = {"container":"_1T4Yi","expanded":"_1UzMA"};